const searchState  = () => {
    return {
        searchTerm:"",
        searchResult:null,
        technicalError: null
    };
  };


  export default searchState;